var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { BenefitCardMW, BenefitCardHalfWidthDTW, } from '../../../shared/rewards-hub';
import { SQUARE_BENEFITS_CONSTANTS as constants } from './Constants';
import { SquareBenefitsLogo, SquareHeaderDTW, SquareBenefitsHeadline, SquareConent, } from './Components';
var SquareBenefitsMW = function (props) {
    var isLocked = props.isLocked, discountAmount = props.discountAmount;
    var Content = function () { return (React.createElement("div", { "data-testid": "sb-container", className: "sui-flex sui-justify-between sui-gap-14" },
        React.createElement("div", null,
            !isLocked && React.createElement(SquareBenefitsHeadline, { amt: discountAmount }),
            React.createElement(SquareConent, __assign({}, props))),
        React.createElement(SquareBenefitsLogo, null))); };
    var data = __assign(__assign({}, props), { isLocked: isLocked, title: isLocked ? constants.TITLE(discountAmount) : undefined, content: React.createElement(Content, null) });
    return React.createElement(BenefitCardMW, __assign({}, data, { hideIcon: true, showContent: true }));
};
var SquareBenefitsFullWidthDTW = function (props) { return React.createElement(React.Fragment, null); };
var SquareBenefitsHalfWidthDTW = function (props) {
    var isLocked = props.isLocked, discountAmount = props.discountAmount;
    var Content = function () { return (React.createElement("div", { "data-testid": "sb-container", className: "sui-relative sui-mb-[-24px]" },
        React.createElement(SquareHeaderDTW, null),
        React.createElement("div", { className: "sui-h-24" }),
        React.createElement(SquareBenefitsHeadline, { amt: discountAmount }),
        React.createElement(SquareConent, __assign({}, props)))); };
    var data = __assign(__assign({}, props), { isLocked: isLocked, content: React.createElement(Content, null) });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var SquareBenefits = function (props) {
    var isMobile = props.isMobile, isLocked = props.isLocked, fullWidth = props.fullWidth, tierName = props.tierName;
    var discountAmount = tierName === 'VIP' ? '$5,000' : '$3,000';
    var data = { isMobile: isMobile, isLocked: isLocked, tierName: tierName, discountAmount: discountAmount };
    if (isMobile)
        return React.createElement(SquareBenefitsMW, __assign({}, data));
    if (fullWidth)
        return React.createElement(SquareBenefitsFullWidthDTW, __assign({}, data));
    return React.createElement(SquareBenefitsHalfWidthDTW, __assign({}, data));
};
